import FlashLib from "flashlib_onlyplay";
import animationCreator from 'Engine/animations/animationCreator';
import animationTypes from '../animations/animationTypes';

export default class BackgroundContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        // this.createTweens();
        if (!PIXI.isMobile.any)this.initAnimation();
        this.active = false;
        this.addListeners();
    }

    init() {
        // this.freeSpinsBackground = this.getChildByName('freeSpinsBackground');
        // this.freeSpinsBackground.visible = false;
    }
    addListeners() {
        window.OPWrapperService.eventManager.add(
          window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
          this.onResize,
          this
        );
    }

    onResize (data) {
        if (data.isLandscape) {
            this.goToFrame(2)
            this.isPortrait = false;
            // this.animation.state.setAnimation(0, 'bg_coins_joker_x_mas', true);
        } else if (data.isMobile && data.isPortrait) {
            this.goToFrame(1)
            this.isPortrait = true;
            // this.animation.state.setAnimation(0, 'bg_coins_joker_x_mas_mob', true);
        }
    }

    initAnimation() {
        this.animation = animationCreator.createAnimation(animationTypes.BACKGROUND);
        this.animation.state.setAnimation(0, 'back_snow', true);
        this.getChildByName('animationContainer').addChild(this.animation);
    }
}
